import './../css/aos.css';
import './../css/bootstrap.min.css';
import './../css/main.css';

import { skillsFE, skillsBE, skillsDB, jobHistory } from './../../Utils/data';

import { useEffect } from "react"
import AOS from "aos";

export const DetailsExperience = ({handleOnClick, titleClicked}) => {
    useEffect(() => {
        AOS.init();
        AOS.refreshHard();
      }, []);

      useEffect(() => {
        AOS.refreshHard();
      }, [titleClicked]);

    return (
        titleClicked === 2 && (<div class="page-content" onClick={handleOnClick}>
            <div class="container">
                <div class="cover shadow-lg bg-white">
                    <div class="cover-bg p-3 p-lg-4 text-white">
                        <div class="row">
                        </div>
                    </div>
                </div>
                <div class="cover-title shadow-lg bg-dark text-light">
                    <div class="skills-section px-3-custom px-lg-4 pt-5">
                        <h2 class="h3 mb-3">Professional Skill Levels</h2>
                        <div class="row">
                        <div class="col-md-4">
                            {
                                skillsFE.map((skill, index) => (
                                    <div key={index} class="mb-2">
                                        <div class="row">
                                            <div class="col-md-8">{skill.name}</div>
                                            <div class="col-md-4 div-year">+{skill.years} years</div>
                                        </div>
                                        
                                        <div class="progress my-1">
                                            <div    class="progress-bar bg-success progress-bar-striped progress-bar-animated" 
                                                    data-aos-duration="3000" 
                                                    role="progressbar" 
                                                    data-aos="zoom-in-right" 
                                                    data-aos-delay={skill.delay} 
                                                    data-aos-anchor=".skills-section" 
                                                    style={skill.width} ></div>
                                        </div>
                                    </div>
                                ))
                            }
                        </div>
                        <div class="col-md-4">
                            {
                                skillsBE.map((skill, index) => (
                                    <div key={index} class="mb-2">
                                        <div class="row">
                                            <div class="col-md-8">{skill.name}</div>
                                            <div class="col-md-4 div-year">+{skill.years} years</div>
                                        </div>

                                        <div class="progress my-1">
                                            <div    class="progress-bar bg-primary progress-bar-striped progress-bar-animated" 
                                                    data-aos-duration="3000" 
                                                    role="progressbar" 
                                                    data-aos="zoom-in-right" 
                                                    data-aos-delay={skill.delay} 
                                                    data-aos-anchor=".skills-section" 
                                                    style={skill.width} ></div>
                                        </div>
                                    </div>
                                ))
                            }  
                        </div>
                        <div class="col-md-4">
                            {
                                skillsDB.map((skill, index) => (
                                    <div key={index} class="mb-2">
                                        <div class="row">
                                            <div class="col-md-8">{skill.name}</div>
                                            <div class="col-md-4">+{skill.years} years</div>
                                        </div>
                                        
                                        <div class="progress my-1">
                                            <div    class="progress-bar bg-WARNING progress-bar-striped progress-bar-animated" 
                                                    data-aos-duration="3000" 
                                                    role="progressbar" 
                                                    data-aos="zoom-in-right" 
                                                    data-aos-delay={skill.delay} 
                                                    data-aos-anchor=".skills-section" 
                                                    style={skill.width} ></div>
                                        </div>
                                    </div>
                                ))
                            }   
                        </div>
                        </div>
                    </div>
                    <hr class="d-print-none"/>
                    <div class="work-experience-section px-3-custom px-lg-4">
                        <h2 class="h3 mb-4">Work Experience</h2>
                        <div class="timeline">
                            {
                                jobHistory.map((job, index) => (
                                    <div key={index} class="timeline-card timeline-card-success card shadow-sm bg-secondary">
                                        <div class="card-body">
                                            <div class="h5 mb-1">{job.position} <span class="text-success h6">at {job.company}</span></div>
                                            <div class="text-white text-small mb-2">{job.date}</div>
                                            <div style={{whiteSpace:"pre-line"}}>{job.description}</div><br></br>
                                            <span><b>Frameworks, libraries, and tools used:</b></span>
                                            <div>
                                                {job.skillsUsed.map((skill, index) => (
                                                    <span key={index} className="badge rounded-pill bg-success">{skill}</span>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                ))
                            }
                            
                        </div>
                    </div>
                </div>
            </div>
        </div>)
    )
}